setTimeout(() => {
  console.log('sa')
    let cartItems = document.querySelector('.line-item-table__list')
    if ( cartItems) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
               console.log('sa')
            });
        });
        observer.observe( cartItems, {
            childList: true
        });
    }
}, 2500)